import React from "react";
import Button from "./Button";

const DEFAULT_PRE_ICON = <i className="fal fa-save"></i>;

/**
 * A "Save"-style affirmative action button - use for Save/Grant/etc. actions.
 * @param {React.ReactNode} [props.children="Save"] - Button label.
 * @param {React.ReactNode} [props.preIcon=<save icon>] - Icon before the label, overridable (e.g. a spinner while submitting).
 * @param {React.ReactNode} [props.postIcon=null] - Icon after the label.
 */
function PositiveButton({ children = "Save", preIcon = DEFAULT_PRE_ICON, postIcon = null, ...props }) {
    return (
        <Button variant="primary" {...props}>
            {preIcon}
            {children}
            {postIcon}
        </Button>
    );
}

export default PositiveButton;
